var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9709 11.0087L11.75 9.46019V6.56325L13.9709 5.0147C13.9711 5.01469 13.9713 5.01469 13.9714 5.01468C13.9735 5.01462 13.9773 5.0148 13.9824 5.01597C13.9876 5.01715 13.9931 5.0191 13.9982 5.0217C13.9988 5.02201 13.9994 5.02233 14 5.02264V11.0008C13.9994 11.0011 13.9988 11.0014 13.9982 11.0017C13.9931 11.0043 13.9876 11.0063 13.9824 11.0075C13.9773 11.0086 13.9735 11.0088 13.9714 11.0088C13.9713 11.0088 13.9711 11.0087 13.9709 11.0087ZM2.35156 4.25H9.125C9.32016 4.25 9.5 4.42984 9.5 4.625V11.3984C9.5 11.5733 9.3408 11.75 9.125 11.75H2.35156C2.1564 11.75 2 11.5936 2 11.3984V4.625C2 4.4092 2.17675 4.25 2.35156 4.25Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/VideoCamera.81888e6d51ef0652f8891cbc181ac300.svg";
export { ForwardRef as ReactComponent };